import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// svgs
import bolt from '../Assets/bolt.svg';
import halfCircle from '../Assets/one-half-circle.svg';
import star from '../Assets/star.svg';
import time from '../Assets/time.png';
import heroImg from '../Assets/cuate.svg'
import { ExamCompassContext } from '../Context/context';

type HeroProps = {
  setCurrentPage: React.Dispatch<React.SetStateAction<string>>
}

const Hero: React.FC<HeroProps> = ({ setCurrentPage }) => {
  const { toDashboard } = useContext(ExamCompassContext);

  return (
    <section id='home' className='pt-24 pb-40 md:pb-28 relative overflow-hidden'>
      <img src={bolt} alt='Bolt' className='absolute top-24 md:top-28 lg:top-56 md:left-8'  />
      <img src={star} alt='Star' className='absolute top-36 right-3 md:right-12 ' />
      <div className='container flex flex-col md:flex-row items-center justify-around lg:px-[100px] gap-10 md:gap-0 lg:gap-5'>
        <div className='w-[349px]  mt-24'>
          <h2 className='text-[36px] md:text-[26px] lg:text-[36px] text-darkText font-bold mb-5'>Ace Your UTME <br /> with ExamCompass!</h2>
          <p className='w-[329px] md:w-[280px] text-[20px] md:text-[18px] lg:text-[20px]  text-textColor mb-16'>Tailored notes, AI-powered assistance, and practice tools to help you succeed.</p>
          <div className='flex items-center gap-4'>
            {localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
              ? <button onClick={() => {toDashboard && toDashboard(); setCurrentPage('home')}} className='px-[32px] py-[8px] md:px-[20px] md:py-[8px] lg:px-[32px] lg:py-[8px] border border-darkGreen bg-darkGreen text-white rounded-[4px]'>Get started</button>
              : <Link to={'/register'} onClick={() => setCurrentPage('home')}><button className='px-[32px] py-[8px] md:px-[20px] md:py-[8px] lg:px-[32px] lg:py-[8px] border border-darkGreen bg-darkGreen text-white rounded-[4px]'>Get started</button></Link>}
            <HashLink to={'/#how-it-works'} onClick={() => setCurrentPage('features')}><button className='px-[32px] py-[8px] md:px-[20px] md:py-[8px] lg:px-[32px] lg:py-[8px] border border-darkGreen text-darkGreen rounded-[4px]'>Learn More</button></HashLink>
          </div>
        </div>
        <div className='w-[590px] flex items-center justify-center relative'>
          <div className='hidden md:w-[300px] lg:w-[590px] md:flex items-center justify-center relative'>
            <img src={heroImg} alt="Hero-img w-fit" />
          </div>
        </div>
      </div>
      <img src={halfCircle} alt='Semi-circle' className='absolute left-0' />
      <img src={time} alt='time' className='absolute right-12' />
    </section>
  )
}

export default Hero